import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';
import { type Library } from '@air/api/types';

import META from '~/hooks/events/useTrackViewedLibrary.meta';

export type TrackViewedLibraryParams = {
  library_id: Library['id'];
};

export const useTrackViewedLibrary = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedLibrary = useCallback(
    (params: TrackViewedLibraryParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackViewedLibrary };
};
